// No imports: api/ functions use this too and can't resolve the "@/" alias.
// Keep in step with DEFAULTS.ARTIST (src/constants/app.constants.ts).
const PLACEHOLDER = 'unknown artist';

/** Artist text safe to show, or null when there is no real artist. */
export function displayArtist(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const v = value.trim();
  return !v || v.toLowerCase() === PLACEHOLDER ? null : v;
}
